import { type RefObject, useEffect } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  callBack: () => void,
) => {
  useEffect(() => {
    const handleClick = (event: Event) => {
      const target = event.target;
      const dataCancelOutsideClickAttr =
        target instanceof HTMLElement
          ? target.dataset.cancelOutsideClick
          : undefined;
      if (
        typeof callBack === 'function' &&
        ref.current &&
        target instanceof Node &&
        !ref.current.contains(target) &&
        !dataCancelOutsideClickAttr
      ) {
        callBack();
      }
    };
    document.addEventListener('click', handleClick, true);
    document.addEventListener('touchstart', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('touchstart', handleClick, true);
    };
  }, [callBack, ref]);
};
